import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getPlanById } from "../constants/upgradePlans";
import { fetchBusiness } from "../api/business";

export default function SuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const planIdParam = params.get("planId");

  const [planState, setPlanState] = useState({
    loading: true,
    planId: null,
    businessName: "",
    error: "",
  });

  useEffect(() => {
    let mounted = true;
    const resolveBusinessPlan = async () => {
      const biz = await fetchBusiness();
      if (!mounted) return;

      if (biz === undefined) {
        setPlanState((prev) => ({
          ...prev,
          loading: false,
          error:
            "We couldn't verify your plan automatically. Your dashboard will refresh once the new plan is synced.",
        }));
        return;
      }

      if (biz) {
        try {
          localStorage.setItem("business", JSON.stringify(biz));
        } catch {
          // ignore
        }
      }

      setPlanState({
        loading: false,
        planId: biz?.plan || null,
        businessName: biz?.name || "",
        error: "",
      });
    };

    resolveBusinessPlan();
    return () => {
      mounted = false;
    };
  }, []);

  const plan = useMemo(() => {
    const fallbackPlanId = planState.planId || undefined;
    return getPlanById(planIdParam || fallbackPlanId);
  }, [planIdParam, planState.planId]);

  const isLifetime = plan?.badge?.toLowerCase().includes("lifetime");
  const heading = isLifetime
    ? `Welcome to ${plan.name}!`
    : `Welcome to the ${plan.name}!`;
  const subcopy = isLifetime
    ? "Your lifetime license is now active. Enjoy unlimited access to every feature, forever."
    : "Your subscription is active – you now have higher limits, analytics, and premium support.";
  const planPerks = plan?.keyPoints || [];
  const loadingLabel = !plan && planState.loading ? "Confirming your plan…" : null;

  return (
    <div className="success-container" style={{ textAlign: "center", marginTop: 60 }}>
      <h2 style={{ color: "#2563eb" }}>{plan ? heading : "Payment confirmed"}</h2>
      <p style={{ fontSize: 18, marginTop: 16 }}>
        Your payment was successful.<br />
        {plan ? (
          <>
            {planState.businessName ? `${planState.businessName} is now on the ${plan.name}. ` : null}
            {subcopy}
          </>
        ) : (
          "Give us a second while we confirm the new plan on your account."
        )}
        <br />
        Need anything? Email <a href="mailto:info@brandmykitchen.com">info@brandmykitchen.com</a>.
      </p>
      {loadingLabel && <p style={{ marginTop: 12, color: "#6b7280" }}>{loadingLabel}</p>}
      {plan && planPerks.length > 0 && (
        <div
          style={{
            margin: "32px auto 0",
            maxWidth: 520,
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            padding: 20,
            textAlign: "left",
            background: "#f9fafb",
          }}
        >
          <h3 style={{ margin: 0, fontSize: 18, color: "#111827" }}>
            What your {plan.name} includes
          </h3>
          <ul style={{ marginTop: 12, paddingLeft: 20, color: "#4b5563" }}>
            {planPerks.map((perk) => (
              <li key={perk}>{perk}</li>
            ))}
          </ul>
        </div>
      )}
      {planState.error && (
        <p style={{ marginTop: 16, color: "#b45309" }}>{planState.error}</p>
      )}
      <div style={{ marginTop: 32 }}>
        <button
          style={{ padding: "12px 32px", borderRadius: 8, background: "#2563eb", color: "#fff", fontWeight: "bold", fontSize: 18, border: "none", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}
